import styled from 'styled-components';
import { Form as FormComponent } from '@unform/web';

import { colors } from '../../../../styles/tokens';

export const Form = styled(FormComponent)`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const BackLink = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 24px auto 0;

  background: transparent;
  border: none;

  color: ${colors.onSurfaceVariant};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    color: ${colors.onSurface};
  }
`;
